"use client";

import AppLogo from "./AppLogo";
import AppDownloadButton from "./button/AppDownloadButton";
import AppIcon from "./Icon";

export default function Footer() {

    const currentYear = new Date().getFullYear();

    return (
        <div className="bg-[url('/images/bg-lines-1.svg')] bg-cover bg-center">
            <div className="footer w-full bg-white dark:bg-black opacity-85 dark:opacity-90">
                <div className="top grid grid-flow-row grid-cols-1 md:grid-cols-12 lg:gap-x-4 px-5 md:px-37.5 py-20">
                    <div className="col-span-5">
                        <AppLogo />
                        <p className="py-5 pr-5 text-gray-500 dark:text-gray-300">
                            Enanpay is committed to creating a seamless and inclusive financial ecosystem in Nigeria. Earn money, pay bills, and stay connected 
                            with affordable data plans.
                        </p>
                    </div>
                    <div className="col-span-2">
                        <h2 className="title">Company</h2>
                        <ul>
                            <li><a href="/about-us">About Us</a></li>
                            <li><a href="/contact-us">Contact Us</a></li>
                        </ul>
                    </div>
                    <div className="col-span-2">
                        <h2 className="title">Legal</h2>
                        <ul>
                            <li><a href="/legal/privacy-policy">Privacy Policy</a></li>
                            <li><a href="/legal/terms-of-service">Terms of Service</a></li>
                        </ul>
                    </div>
                    <div className="col-span-3 mt-10 md:mt-0">
                        <div className="mb-10">
                            <h2 className="title">Social Media</h2>
                            <ul className="social">
                                <li>
                                    <a href="https://www.facebook.com/enanpaycom">
                                        <AppIcon icon="facebook" className="text-2xl" />
                                        <span className="sr-only">Facebook</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://x.com/enanpay">
                                        <AppIcon icon="x" className="text-2xl" />
                                        <span className="sr-only">X</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/enanpay">
                                        <AppIcon icon="instagram" className="text-2xl" />
                                        <span className="sr-only">Instagram</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/company/enanpay">
                                        <AppIcon icon="linkedin" className="text-2xl" />
                                        <span className="sr-only">LinkedIn</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.tiktok.com/@enanpay">
                                        <AppIcon icon="tiktok" className="text-2xl" />
                                        <span className="sr-only">TikTok</span>
                                    </a>
                                </li>
                                {/* <li><a href="">Pintrest</a></li> */}
                            </ul>
                        </div>
                        <div>
                            <h2 className="title">Download Enanpay App</h2>
                            <div className="flex gap-2">
                                <AppDownloadButton 
                                    type="google"
                                    size="xs"
                                />
                                <AppDownloadButton 
                                    type="apple"
                                    size="xs"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center text-gray-500 dark:text-gray-300 border-t border-gray-200 dark:border-gray-800 py-5">
                    <p>
                        &copy; { currentYear } <a href="/" className="hover:text-blue-500">Enanpay</a>. All right reserved.
                    </p>
                </div>
            </div>
        </div>
    );
}